import React, { useMemo, useState, useEffect } from "react";
import { withTranslation } from "react-i18next";

import { Modal, ModalBody } from "reactstrap";
import crossIcon from "../../../../../../assets/images/cross.svg";
import StaffDefaultImage from "../../../../../../assets/images/staff-default-rounded.png";
import Text from "components/Text";
import styles from "../styles.module.scss";
import "../styles.scss";
import "react-accessible-accordion/dist/fancy-example.css";
import Empty from "components/Empty";

function OfficesModal({
  t,
  isOfficeModalOpen,
  setIsOfficeModalOpen,
  selectedOfficeIds,
  setSelectedOfficeIds,
  offices,
}) {
  const [selectedOffice, setSelectedOffice] = useState([...selectedOfficeIds]);
  const [search, setSearch] = useState("");
  const [filteredOffices, setFilteredOffices] = useState(offices || []);

  // Update filtered offices when offices prop changes
  useEffect(() => {
    setFilteredOffices(offices || []);
  }, [offices]);

  // Update local state when modal opens with new selectedOfficeIds
  useEffect(() => {
    if (isOfficeModalOpen) {
      setSelectedOffice([...selectedOfficeIds]);
    }
  }, [isOfficeModalOpen, selectedOfficeIds]);

  // FIX: Search functionality
  const onSearch = (val) => {
    setSearch(val);
    const value = val.trim();

    if (!value) {
      setFilteredOffices(offices || []);
      return;
    }

    if (!offices) return;

    const trimmedSearchValue = value.replace(/\s+/g, "").toLowerCase();
    const filterArray = offices.filter((item) => {
      const officeName = item?.name?.replace(/\s+/g, "").toLowerCase() || "";
      return officeName.includes(trimmedSearchValue);
    });

    setFilteredOffices(filterArray);
  };

  // FIX: Properly toggle individual office
  const checkOffice = (office) => {
    setSelectedOffice((prev) => {
      const index = prev.findIndex((item) => item.OfficeId === office.id);

      if (index > -1) {
        // Already selected - remove it
        return prev.filter((item) => item.OfficeId !== office.id);
      } else {
        // Not selected - add it
        return [
          ...prev,
          {
            id: 0,
            OfficeId: office.id,
            name: office.name, // Store the name for display
          },
        ];
      }
    });
  };

  const checkMemberOfficeAvaliable = (array, value) => {
    return array?.some((e) => e?.OfficeId === value?.id);
  };

  // FIX: Correct calculation of total offices count
  const allValues = useMemo(() => {
    return offices?.length || 0;
  }, [offices]);

  // FIX: Check if all offices are selected
  const selectAll = useMemo(
    () => allValues > 0 && selectedOffice?.length === allValues,
    [allValues, selectedOffice]
  );

  const handleAllChange = (e) => {
    const checked = e.target.checked;
    const values = [];

    if (checked) {
      offices.forEach((val) => {
        // Check if already exists in selectedOfficeIds
        const existing = selectedOfficeIds.find(
          (item) => item.OfficeId === val.id
        );

        values.push({
          id: existing?.id || 0,
          OfficeId: val.id,
          name: val.name, // Store the name
        });
      });
    } else {
      // Keep only items that have an id (already saved in database)
      selectedOfficeIds.forEach((res) => {
        if (res.id) {
          values.push({ ...res });
        }
      });
    }
    setSelectedOffice(values);
  };

  return (
    <Modal
      isOpen={isOfficeModalOpen}
      toggle={() => setIsOfficeModalOpen(false)}
      className="modal-dialog-centered modal-width-660 new-group-modal"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => setIsOfficeModalOpen(false)}>
        <img src={crossIcon} alt="close" />
      </span>

      <ModalBody>
        {/* Header */}
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          Select Office
        </Text>

        {/* Search box */}
        <div className={"search-box w-100 " + styles["search-box"]}>
          <input
            type="text"
            placeholder={t("accountOwner.searchByName")}
            value={search}
            onChange={(e) => onSearch(e.currentTarget.value)}
          />
          <span className="ico">
            <img
              src={require("assets/images/search-icon.svg").default}
              alt="icon"
            />
          </span>
        </div>

        {/* FIX: Selection counter - should show selectedOffice.length */}
        <Text
          size="12px"
          marginBottom="20px"
          marginTop="20px"
          weight="400"
          color="rgb(111, 119, 136)"
        >
          {selectedOffice.length} {t("Selected")}
        </Text>

        {/* Select all checkbox */}
        {offices?.length > 0 && (
          <div className="ch-checkbox c-field all-event-checkbox m-0">
            <label>
              <input
                type="checkbox"
                onChange={handleAllChange}
                checked={selectAll}
              />
              <span>{t("staff.selectAll")}</span>
            </label>
          </div>
        )}

        {/* Office list */}
        <ul className="modal-employee-list group-list" id="scrollableDiv">
          {filteredOffices?.length > 0 ? (
            filteredOffices.map((item) => {
              return (
                <li key={item.id}>
                  <div className={`${styles.border_list} ch-checkbox`}>
                    <label>
                      <input
                        type="checkbox"
                        checked={checkMemberOfficeAvaliable(
                          selectedOffice,
                          item
                        )}
                        onChange={() => checkOffice(item)}
                      />
                      <span className="d-flex align-items-center">
                        <img
                          src={item?.officeImage || StaffDefaultImage}
                          alt="profile-pic"
                          className={styles.Default_staff_image}
                        />
                        <p className="m-0">{item?.name}</p>
                      </span>
                    </label>
                  </div>
                </li>
              );
            })
          ) : (
            <li className="text-center py-3">
              <Empty Message={t("noDataAvaliableForSelectoion")} />
            </li>
          )}
        </ul>

        {/* Footer buttons */}
        <button
          className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100 mt-4"
          title={t("accountOwner.addEmployees")}
          onClick={() => {
            setSelectedOfficeIds(selectedOffice);
            setIsOfficeModalOpen(false);
          }}
        >
          {t("staff.select")}
        </button>
        <button
          className="button button-round button-border btn-mobile-link button-dark mb-md-3 mt-md-4"
          onClick={() => {
            setIsOfficeModalOpen(false);
            // Reset to original selection if cancelled
            setSelectedOffice([...selectedOfficeIds]);
            setSearch("");
          }}
          title={t("cancel")}
        >
          {t("cancel")}
        </button>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(OfficesModal);
